import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { getBorderRadius, getPadding, getBorderWidth } from '@volt_developers/foundations';
import { TAG_COLORS } from './styles.js';

const Tag = (_a) => {
    var { label, inactive, isError } = _a, rest = __rest(_a, ["label", "inactive", "isError"]);
    return (jsx(SquaredTag, Object.assign({ "$inactive": inactive, "$isError": isError }, rest, { children: label })));
};
const SquaredTag = styled("span")(({ $inactive, $isError }) => {
    const tagVariant = getTagVariant({ $inactive, $isError });
    return {
        display: "inline-flex",
        boxSizing: "border-box",
        borderRadius: getBorderRadius(1),
        padding: getPadding(1, 3),
        fontSize: 10,
        fontWeight: 500,
        lineHeight: "14px",
        height: "fit-content",
        textTransform: "uppercase",
        letterSpacing: 1,
        textIndent: 1,
        backgroundColor: TAG_COLORS.background[tagVariant],
        color: TAG_COLORS.body[tagVariant],
        border: `${getBorderWidth(1)} solid ${TAG_COLORS.border[tagVariant]}`,
    };
});
function getTagVariant({ $inactive, $isError }) {
    if ($isError) {
        return "error";
    }
    if ($inactive) {
        return "inactive";
    }
    return "default";
}

export { Tag };
//# sourceMappingURL=Tag.js.map
